import { api } from "./client";
import type { Contact, Interaction, Task } from "../types";

export interface ListContactsParams {
  q?: string;
  tags?: string;
  company_id?: string;
  language?: string;
  campaign_slug?: string;
  limit?: number;
  offset?: number;
  [key: string]: unknown;
}

export const contactsApi = {
  list: (params: ListContactsParams = {}) =>
    api.get<Contact[]>("/api/v1/contacts", params),
  get: (id: string) => api.get<Contact>(`/api/v1/contacts/${id}`),
  patch: (id: string, data: Record<string, unknown>) =>
    api.patch<Contact>(`/api/v1/contacts/${id}`, { data }),
  tasks: (id: string, limit = 50) =>
    api.get<Task[]>(`/api/v1/contacts/${id}/tasks`, { limit }),
  interactions: (id: string, limit = 50, type?: string) =>
    api.get<Interaction[]>(`/api/v1/contacts/${id}/interactions`, {
      limit,
      ...(type ? { interaction_type: type } : {}),
    }),
  upsertMembership: (
    id: string,
    slug: string,
    patch: Record<string, unknown>,
  ) =>
    api.put<Contact>(`/api/v1/contacts/${id}/memberships/${slug}`, { patch }),
};
